import * as Models from "../../../Models";
import * as Services from "../../../Services";
import * as _ from "lodash";
import * as toastr from "toastr";

export interface ICloneMarketScope extends ng.IScope {
    cloneSrecPriceCurveCtrl: CloneSrecPriceCurveCtrl;
}

export class CloneSrecPriceCurveCtrl {
    public cloneSrecPriceCurveRequest: Models.CostCalculation.CloneSrecPriceCurveRequest.ICloneSrecPriceCurveRequest;

    public static $inject = ['$scope', '$modalInstance', '$state', 'SrecPriceCurveApiClient', 'srecPriceCurvesModel'];
    constructor(
        public $scope: ICloneMarketScope,
        public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
        public $state: angular.ui.IStateService,
        public srecPriceCurveApiClient: Services.SrecPriceCurveApiClient.ISrecPriceCurveApiClient,
        public srecPriceCurvesModel: Models.CostCalculation.MarketAssumedValuesModel.ISrecPriceCurves) {

        $scope.cloneSrecPriceCurveCtrl = this;

        this.cloneSrecPriceCurveRequest = new Models.CostCalculation.CloneSrecPriceCurveRequest.CloneSrecPriceCurveRequest(_.cloneDeep(srecPriceCurvesModel));
    }

    public cloneSrecPriceCurve = (): void => {
        this.srecPriceCurveApiClient.cloneSrecPriceCurve(this.cloneSrecPriceCurveRequest)
            .then((cloneSrecPriceCurveResponse: Models.CostCalculation.MarketAssumedValuesModel.ICloneSrecPriceCurveResponse) => {
                if (!cloneSrecPriceCurveResponse.success) {
                    const errorString =
                        cloneSrecPriceCurveResponse.errors.reduce((strOne, strTwo) => strOne + strTwo + '\r\n');
                    toastr.error(errorString);
                } else {
                    this.$modalInstance.close(cloneSrecPriceCurveResponse);
                }
            });
    }

    public closeModal = (): void => {
        this.$modalInstance.close();
    }
}